import Vue from 'vue'
import moment from 'moment'
import Util from './util'

Vue.filter('WeekDate', date => Util.getWeek(date));


// WEBPACK FOOTER //
// ./src/filter/index.js